import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router'
import { AuthService, UserService } from '../api'
import { Observable, catchError, map, of } from 'rxjs'
import { onboardingPath, onboardingStep } from '@/app/utils/onboarding'

@Injectable({ providedIn: 'root' })
export class OnboardingGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private users: UserService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> {
    if (!this.auth.isAuthenticated()) {
      return this.router.createUrlTree(['/auth/sign-in/ldap'])
    }
    return this.users.loadCurrentUser().pipe(
      map((user) => {
        const step = onboardingStep(user)
        if (!step) {
          const path = route.routeConfig?.path
          return path === 'auth/change-password' || path === 'auth/set-password'
            ? true
            : this.router.createUrlTree(['/'])
        }
        const expected = onboardingPath(step).split('/').pop()
        return route.routeConfig?.path === `auth/${expected}`
          ? true
          : this.router.createUrlTree([onboardingPath(step)])
      }),
      catchError(() => of(this.router.createUrlTree(['/auth/sign-in/ldap'])))
    )
  }
}
